import { Message } from "./message";

type Callback = (msg: Message) => void;

export class WSClient {
  private socket: WebSocket;
  private listeners = new Set<Callback>();
  private pingInterval: NodeJS.Timer | null = null;
  private syncInterval: NodeJS.Timer | null = null;

  constructor(url: string) {
    this.socket = new WebSocket(url);

    this.socket.onopen = () => {
      console.log("WebSocket connection opened");
      this.send({ type: "ping" });
      this.pingInterval = setInterval(() => {
        if (this.socket.readyState === WebSocket.OPEN) {
          this.send({ type: "ping" });
        }
      }, 5000);
      this.syncInterval = setInterval(() => {
        if (this.socket.readyState === WebSocket.OPEN) {
          this.send({ type: "request-sync" });
        }
      }, 5000);
    };

    this.socket.onclose = () => {
      console.log("WebSocket connection closed");
      if (this.pingInterval) {
        clearInterval(this.pingInterval);
        this.pingInterval = null;
      }
    };

    this.socket.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data) as Message;
        if (msg.type === "error") {
          console.error("WebSocket error:", msg.error);
          return;
        } else if (msg.type === "pong") {
          console.log("Received pong");
          return;
        }
        this.listeners.forEach((cb) => cb(msg));
      } catch {
        console.warn("Invalid WS message:", event.data);
      }
    };

    this.socket.onerror = () => this.socket.close();
  }

  send(msg: unknown) {
    if (this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(msg));
    }
  }

  onMessage(cb: Callback) {
    this.listeners.add(cb);
    return () => {
      this.listeners.delete(cb)
    };
  }
}
